import { FlaggedIssuesError } from "./FlaggedIssuesError";

export default FlaggedIssuesError;
